import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import { ReactNode } from 'react';
import classes from './Title.module.scss';

export default function Title({
  children,
  className,
  sx,
  variant = 'h2',
  ...rest
}: TitleProps) {
  return (
    <Box
      className={clsx(classes.root, classes[variant], className)}
      component="h2"
      sx={{ mb: 2, mt: 4, ...sx }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export interface TitleProps extends BoxProps {
  children: ReactNode;
  className?: string;
  variant?: 'h1' | 'h2' | 'h3';
}
